import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class NotificationsChannelsSettingsActionsValidator {

    notification_type = [
        Validators.required
    ];

    notification_channel = [
        Validators.required
    ];

    delivery_address = [
        Validators.required
    ]

    // Error messages
    errorMessages = {
        
        notification_type: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        notification_channel: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        delivery_address: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
    }
}